export const API_URL = "https://api.domagolf.com/v1/";
export const NEW_API_URL = "https://api2.domagolf.com/api/";
export const REACT_URL = "https://backend.domagolf.com/v2";
export const FRONT_URL = "https://backend.domagolf.com";
export default {};
